import {API} from 'shared/constants/AppEnums';

export const getCounterBPK = async (mode) => {
  try {
    const params = new URLSearchParams();
    if (mode) params.append('mode', mode);

    const url = `${API.GET_COUNTER_BPK}${params.toString() ? `?${params.toString()}` : ''}`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: sessionStorage.getItem('token'),
      },
    });

    return response.json();
  } catch (error) {
    return error;
  }
};

// PERMINDOK
export const getListPermindok = async (page, search) => {
  try {
    const params = new URLSearchParams();

    if (page) params.append('page', page);
    if (search) params.append('search', search);

    const basePath = `${API.GET_LIST_PERMINDOK}parent/`;

    const url = `${basePath}${
      params.toString() ? `?${params.toString()}` : ''
    }`;

    const response = await fetch(url, {
      headers: {
        Authorization: sessionStorage.getItem('token'),
      },
    });

    return response.json();
  } catch (error) {
    return error;
  }
};

export const getListPermindokMonitoring = async (page, search) => {
  try {
    const params = new URLSearchParams();

    if (page) params.append('page', page);
    if (search) params.append('search', search);

    const basePath = `${API.GET_LIST_PERMINDOK_MONITORING}`;

    const url = `${basePath}${
      params.toString() ? `?${params.toString()}` : ''
    }`;

    const response = await fetch(url, {
      headers: {
        Authorization: sessionStorage.getItem('token'),
      },
    });

    return response.json();
  } catch (error) {
    return error;
  }
};

export const patchReadFile = async (id) => {
  try {
    const response = await fetch(API.PATCH_READ_FILE.replace('$id', id), {
      method: 'PATCH',
      headers: {
        Authorization: sessionStorage.getItem('token'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        is_read: true,
      }),
    });

    return response.json();
  } catch (error) {
    return error;
  }
};

export const downloadAllFolder = async (id) => {
  const response = await fetch(API.DOWNLOAD_ALL_FOLDER.replace('$id', id), {
    method: 'GET',
    headers: {
      Authorization: sessionStorage.getItem('token'),
    },
  });

  if (!response.ok) throw new Error('Download gagal');

  const blob = await response.blob();

  return {
    blob,
    headers: response.headers,
  };
};

export const getDetailPermindok = async (id) => {
  try {
    const response = await fetch(API.GET_DETAIL_PERMINDOK.replace('$id', id), {
      method: 'GET',
      headers: {
        Authorization: sessionStorage.getItem('token'),
      },
    });
    return response.json();
  } catch (error) {
    return error;
  }
};

export const getDetailPermindokMonitoring = async (id) => {
  try {
    const response = await fetch(API.GET_DETAIL_PERMINDOK_MONITORING.replace('$id', id), {
      method: 'GET',
      headers: {
        Authorization: sessionStorage.getItem('token'),
      },
    });
    return response.json();
  } catch (error) {
    return error;
  }
};

export const addPermindok = async (data) => {
  try {
    const response = await fetch(API.ADD_PERMINDOK, {
      method: 'POST',
      headers: {
        Authorization: sessionStorage.getItem('token'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    return response.json();
  } catch (error) {
    return error;
  }
};

export const addPermindokAttachment = async (file) => {
  try {
    var formData = new FormData();
    formData.append('file', file);

    const response = await fetch(API.ADD_PERMINDOK_ATTACHMENT, {
      method: 'POST',
      headers: {
        Authorization: sessionStorage.getItem('token'),
      },
      body: formData,
    });
    return response.json();
  } catch (error) {
    return error;
  }
};

export const addFileKKP = async (file, folder_id) => {
  try {
    var formData = new FormData();
    file.forEach((item) => {
      formData.append('file', item);
    });
    formData.append('folder_id', folder_id);

    const response = await fetch(API.ADD_PERMINDOK_ATTACHMENT, {
      method: 'POST',
      headers: {
        Authorization: sessionStorage.getItem('token'),
      },
      body: formData,
    });
    return response.json();
  } catch (error) {
    return error;
  }
};

export const deleteFileKKP = async (id) => {
  try {
    const response = await fetch(
      API.DELETE_PERMINDOK_ATTACHMENT.replace('$id', id),
      {
        method: 'DELETE',
        headers: {
          Authorization: sessionStorage.getItem('token'),
          'Content-Type': 'application/json',
        },
      },
    );
    return response.json();
  } catch (error) {
    return error;
  }
};

export const addFolderKKP = async (data) => {
  try {
    const response = await fetch(API.ADD_PERMINDOK, {
      method: 'POST',
      headers: {
        Authorization: sessionStorage.getItem('token'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    return response.json();
  } catch (error) {
    throw error;
  }
};

export const deleteFolderKKP = async (id) => {
  try {
    const response = await fetch(API.DELETE_FOLDER_BPK.replace('$id', id), {
      method: 'DELETE',
      headers: {
        Authorization: sessionStorage.getItem('token'),
        'Content-Type': 'application/json',
      },
    });
    return response.json();
  } catch (error) {
    return error;
  }
};

export const editPermindok = async (id, data) => {
  try {
    const response = await fetch(API.EDIT_PERMINDOK.replace('$id', id), {
      method: 'PUT',
      headers: {
        Authorization: sessionStorage.getItem('token'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    return response.json();
  } catch (error) {
    return error;
  }
};

export const deletePermindokAttachment = async (id) => {
  try {
    const response = await fetch(
      API.DELETE_PERMINDOK_ATTACHMENT.replace('$id', id),
      {
        method: 'DELETE',
        headers: {
          Authorization: sessionStorage.getItem('token'),
        },
      },
    );
    return response.json();
  } catch (error) {
    return error;
  }
};

export const getOptionUnkerPermindok = async () => {
  try {
    const response = await fetch(
      `${API.GET_OPTION_UNKER_PERMINDOK}?limit=${20}`,
      {
        method: 'GET',
        headers: {
          Authorization: sessionStorage.getItem('token'),
        },
      },
    );

    return response.json();
  } catch (error) {
    return error;
  }
};

export const dispositionPermindok = async (payload) => {
  try {
    const response = await fetch(API.DISPOSITION_PERMINDOK, {
      method: 'POST',
      headers: {
        Authorization: sessionStorage.getItem('token'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    return response.json();
  } catch (error) {
    return error;
  }
};

// KONSEP TEMUAN //
export const getListKonsepTemuan = async (
  page,
  tipe,
  tipe_dokumen,
  general,
) => {
  try {
    const response = await fetch(
      `${API.GET_LIST_KONSEP_TEMUAN}?page=${
        page + 1
      }&tipe=${tipe}&tipe_dokumen=${tipe_dokumen}&general=${general}`,
      {
        method: 'GET',
        headers: {
          Authorization: sessionStorage.getItem('token'),
        },
      },
    );

    return response.json();
  } catch (error) {
    return error;
  }
};

export const getListKonsepTemuanMonitoring = async (
  page,
  tipe,
  tipe_dokumen,
  general,
) => {
  try {
    const response = await fetch(
      `${API.GET_LIST_KONSEP_TEMUAN_MONITORING}?page=${
        page + 1
      }&tipe=${tipe}&tipe_dokumen=${tipe_dokumen}&general=${general}&monitoring=true`,
      {
        method: 'GET',
        headers: {
          Authorization: sessionStorage.getItem('token'),
        },
      },
    );

    return response.json();
  } catch (error) {
    return error;
  }
};

export const getDetailKonsepTemuan = async (id) => {
  try {
    const response = await fetch(
      `${API.GET_DETAIL_KONSEP_TEMUAN.replace('$id', id)}`,
      {
        method: 'GET',
        headers: {
          Authorization: sessionStorage.getItem('token'),
        },
      },
    );
    return response.json();
  } catch (error) {
    return error;
  }
};

export const addKonsepTemuan = async (payload) => {
  try {
    const response = await fetch(API.ADD_KONSEP_TEMUAN, {
      method: 'POST',
      headers: {
        Authorization: sessionStorage.getItem('token'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    return response.json();
  } catch (error) {
    return error;
  }
};

export const dispositionKonsepTemuan = async (payload) => {
  try {
    const response = await fetch(API.DISPOSITION_KONSEP_TEMUAN, {
      method: 'POST',
      headers: {
        Authorization: sessionStorage.getItem('token'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    return response.json();
  } catch (error) {
    return error;
  }
};

export const feedbackKonsepTemuan = async (payload) => {
  try {
    const response = await fetch(API.FEEDBACK_KONSEP_TEMUAN, {
      method: 'POST',
      headers: {
        Authorization: sessionStorage.getItem('token'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    return response.json();
  } catch (error) {
    return error;
  }
};

export const getListKonsepTemuanKKP = async (
  page,
  tipe,
  tipe_dokumen,
  general,
) => {
  try {
    const response = await fetch(
      `${API.GET_LIST_KONSEP_TEMUAN_KKP}?page=${
        page + 1
      }&tipe=${tipe}&tipe_dokumen=${tipe_dokumen}&general=${general}`,
      {
        method: 'GET',
        headers: {
          Authorization: sessionStorage.getItem('token'),
        },
      },
    );

    return response.json();
  } catch (error) {
    return error;
  }
};

export const getListOptionBPK = async (page, tipe, tipe_dokumen, general) => {
  try {
    const response = await fetch(
      `${API.GET_LIST_OPTION_BPK}?page=${page}&tipe=${tipe}&tipe_dokumen=${tipe_dokumen}&general=${general}`,
      {
        method: 'GET',
        headers: {
          Authorization: sessionStorage.getItem('token'),
        },
      },
    );

    return response.json();
  } catch (error) {
    return error;
  }
};
